import { computed } from 'vue';
import { useFeatureEligibility, useKillswitches } from '@modules/featureControl';
import { useCommonProductGetters } from '@composables/useCommonProductGetters';
import { useProduct } from '@modules/product';
import { useDeviceType } from './utils/useDeviceType';
import { useBrand } from './useBrand';

export default function useSponsoredItems() {
  const { killswitches } = useKillswitches();
  const { isMobile } = useDeviceType();
  const { productData: product } = useProduct();
  const { isMcom } = useBrand();
  const {
    sponsoredItemsEnabled: isMonetizationEnabled,
    enableImpressionTagsForSMProducts,
    enableClickTagsForSMProducts,
    priceSimplificationEnabled,
    carouselOpenInNewTabEnabled,
  } = killswitches;
  const { showSponsoredItemTop, shoppableRedesignOptimization } = useFeatureEligibility();
  const { taxonomy } = useCommonProductGetters();
  const defaultCategoryId = computed(() => taxonomy.value.defaultCategoryId);

  const siteMonConfig = {
    clientId: 'product',
    device: !isMobile.value ? 'desktop' : 'mobile',
    customStyleClass: shoppableRedesignOptimization ? 'small-margin-bottom-m large-margin-bottom-xl' : 'small-margin-bottom-xl large-margin-bottom-xxl',
    isSimplificationOn: priceSimplificationEnabled,
    sponsoredItemsConfig: {
      categoryId: defaultCategoryId.value || '',
      product,
      pageType: 'product',
      showSponsoredItemTop,
    },
  };
  return {
    siteMonConfig,
    isMonetizationEnabled,
    enableImpressionTagsForSMProducts,
    enableClickTagsForSMProducts,
    isMcom,
    carouselOpenInNewTabEnabled,
  };
}
